// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".da3ffdceb633fdeba71856ce95815f4246ac38ed.chunk.js";
};